import React, {useContext} from 'react';

import { CustomizeContext } from "../contexts/customize";

const Option = (props) => {

  const {cleric, ind, name, parent} = props;
  const { customizes, setCustomizes } = useContext(CustomizeContext);

  const optionClick = (e) => {
    const clickButton = e.currentTarget;
    const selectItemParent = e.currentTarget.closest('.mtm-item__wrapper');
    const selectItemName = selectItemParent.id.replace("mtm-", "");
    if (clickButton.classList.contains('checked')) {
      clickButton.classList.remove('checked');
    } else {
      const clericItems = document.querySelectorAll('#mtm-' + selectItemName + ' .options-item__type');
      for(let i = 0; i < clericItems.length; i++){
        if(clericItems[i].classList.contains("checked")) {
          clericItems[i].classList.remove("checked");
        }
      }
      clickButton.classList.add("checked");
      customizes[parent][name].id = clickButton.dataset.id;
      customizes[parent][name].label = clickButton.dataset.label;
      customizes[parent][name].value = clickButton.dataset.value;
      setCustomizes({...customizes});
    }
  }

  return (
    <div 
      className="options-item__type selects-item" 
      key={`${name}-${ind}`}
      onClick={optionClick}
      data-key={name}
      data-id={cleric.id}
      data-label={cleric.label}
      data-value={cleric.value}
      >
      <div
        className="options-item__type__button"
      >
      </div>
      <p className="options-item__type__label">{cleric.label}</p>
      <p className="options-item__type__description">{cleric.description}</p>
    </div>
  );
}
export default Option;